import gql from 'graphql-tag';

const RhymeProjectFragment = gql`
  fragment RhymeProjectFragment on CourseTypeMetadataV1_rhymeProjectMember {
    ... on CourseTypeMetadataV1_rhymeProjectMember {
      rhymeProject {
        typeNameIndex
      }
    }
  }
`;

const StandardCourseFragment = gql`
  fragment StandardCourseFragment on CourseTypeMetadataV1_standardCourseMember {
    ... on CourseTypeMetadataV1_standardCourseMember {
      standardCourse {
        typeNameIndex
      }
    }
  }
`;

const CareerPlansCourseFragment = gql`
  fragment CareerPlansCourseFragment on CoursesV1 {
    id
    slug
    name
    description
    photoUrl
    premiumExperienceVariant
    partners {
      elements {
        id
        name
        squareLogo
      }
    }
    courseTypeMetadata {
      courseTypeMetadata {
        ...RhymeProjectFragment
        ...StandardCourseFragment
      }
    }
    courseDerivativesV2 {
      averageFiveStarRating
      ratingCount
    }
  }
  ${RhymeProjectFragment}
  ${StandardCourseFragment}
`;

const CareerPlansDegreeFragment = gql`
  fragment CareerPlansDegreeFragment on DegreesV1 {
    name
    id
    slug
    logo
    partners {
      elements {
        id
        name
        squareLogo
      }
    }
  }
`;

// Using multiple calls to DegreesV1Resource instead of a multiget because that  is "broken" and relies on IDs.
// Realistically, though, the advantage of this is that it's easier for marketing to pull slugs than it is to
// grab degree IDs.
export const CourseDataQuery = gql`
  query getCourseData($courseIds: [String!]!) {
    CoursesV1Resource {
      multiGet(ids: $courseIds) {
        elements {
          ...CareerPlansCourseFragment
        }
      }
    }
  }
  ${CareerPlansCourseFragment}
`;

export const DegreesDataQuery4 = gql`
  query getDegreesData($degreeSlug1: String!, $degreeSlug2: String!, $degreeSlug3: String!, $degreeSlug4: String!) {
    DegreesV1Resource {
      degrees1: bySlug(slug: $degreeSlug1) {
        elements {
          ...CareerPlansDegreeFragment
        }
      }
      degrees2: bySlug(slug: $degreeSlug2) {
        elements {
          ...CareerPlansDegreeFragment
        }
      }
      degrees3: bySlug(slug: $degreeSlug3) {
        elements {
          ...CareerPlansDegreeFragment
        }
      }
      degrees4: bySlug(slug: $degreeSlug4) {
        elements {
          ...CareerPlansDegreeFragment
        }
      }
    }
  }
  ${CareerPlansDegreeFragment}
`;

export const DegreesDataQuery2 = gql`
  query getTwoDegreesData($degreeSlug1: String!, $degreeSlug2: String!) {
    DegreesV1Resource {
      degrees1: bySlug(slug: $degreeSlug1) {
        elements {
          ...CareerPlansDegreeFragment
        }
      }
      degrees2: bySlug(slug: $degreeSlug2) {
        elements {
          ...CareerPlansDegreeFragment
        }
      }
    }
  }
  ${CareerPlansDegreeFragment}
`;

export const CareerLearningPathsQuery = gql`
  query CareerLearningPathsQuery {
    CareerLearningPathsV1Resource {
      getAll {
        elements {
          id
          name
          slug
          skills
          partnerNames
          careerPaths {
            name
            skillLevel
          }
        }
      }
    }
  }
`;
